import { render, staticRenderFns } from "./NSingleImageUploader.vue?vue&type=template&id=bde33bd6&scoped=true&"
import script from "./NSingleImageUploader.vue?vue&type=script&lang=js&"
export * from "./NSingleImageUploader.vue?vue&type=script&lang=js&"
import style0 from "./NSingleImageUploader.vue?vue&type=style&index=0&id=bde33bd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde33bd6",
  null
  
)

export default component.exports